import { useEffect, useState } from 'react'
import * as React from 'react'
import { isValidAddress, isValidEmail } from '../lib/helpers'
import { resolveENS } from '../api'

import Spinner from 'images/etherscan-spinner.svg'
import { usePrivyWrapper } from '../hooks/usePrivyWrapper'

type Props = {
  onAddress: (address?: string) => void
}

const AddressInput: React.FC<Props> = ({ onAddress }) => {
  const [address, setAddress] = useState<string | undefined>(undefined)
  const [error, setError] = useState<string | undefined>(undefined)
  const [validating, setValidating] = useState<boolean>(false)
  const { connectWallet, lastConnectedWallet } = usePrivyWrapper()

  const handleAddressInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAddress(e.target.value.toLowerCase().trim())
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (address) {
        validateAddress().then()
      } else {
        setError(undefined)
        onAddress()
      }
    }, 1250)

    return () => clearTimeout(delayDebounceFn)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address])

  const validateAddress = async () => {
    setError(undefined)
    setValidating(true)

    if (address && isValidAddress(address)) {
      onAddress(address)
    } else if (address && isValidEmail(address)) {
      onAddress(address)
    } else if (address) {
      try {
        const ensResponse = await resolveENS(address)

        if (ensResponse.valid) {
          onAddress(address)
        } else {
          onAddress(undefined)
          setError('The Address, Email or ENS is invalid.')
        }
      } catch (e) {
        onAddress(undefined)
        setError('The Address, Email or ENS is invalid.')
      }
    } else {
      onAddress(undefined)
      setError('An Address, Email or ENS is required.')
    }

    setValidating(false)
  }

  useEffect(() => {
    if (lastConnectedWallet) {
      setAddress(lastConnectedWallet.address)
    }
  }, [lastConnectedWallet])

  return (
    <div className="address-input-container">
      <input
        type="text"
        placeholder="Email, ENS or Ethereum address"
        className="address-input"
        onChange={handleAddressInputChange}
        value={address ? address : ''}
        disabled={validating}
      />
      {validating && <img src={Spinner} alt="loading" className="address-input-loading" />}
      {error && <span className="bk-error">{error}</span>}
      <span className="web3-input" onClick={connectWallet}>
        Get my address
      </span>
    </div>
  )
}

export default AddressInput
